import * as _ from 'lodash-es';
import { AdminUser } from '../model/adminUser';
import { AdminUsersList } from '../model/adminUsers-list';
import { AdminUserStatusBuilder } from './adminUserStatus-builder';
import { PremiumStatusQueueItemBuilder } from './premium-status-queue-item-builder';
export class AdminUserBuilder {
    static buildAdminUser(data) {
        let adminUser = new AdminUser();
        adminUser.id = data.id;
        adminUser.alias = data.alias;
        adminUser.password = data.password;
        adminUser.level = data.level;
        adminUser.everywhere = data.everywhere;
        adminUser.unreadMsg = data.unread_msg;
        adminUser.active = data.active;
        adminUser.dateCreation = data.date_creation;
        adminUser.dateLogin = data.date_login;
        adminUser.dateLast = data.date_last;
        adminUser.datePassword = data.date_password;
        adminUser.idLastShift = data.id_last_shift;
        adminUser.idLastLot = data.id_last_lot;
        adminUser.id_permissions_group = data.id_permissions_group;
        adminUser.idLot = data.id_lot;
        adminUser.numIn = data.num_in;
        adminUser.pm = data.pm;
        adminUser.email = data.email;
        adminUser.name = data.name;
        adminUser.name_2 = data.name_2;
        adminUser.nif = data.nif;
        adminUser.phone = data.phone;
        adminUser.canRemote = data.can_remote;
        adminUser.photo = data.photo;
        adminUser.appLot = data.app_lot;
        adminUser.canApi = data.can_api;
        adminUser.passwordRecoveryHash = data.password_recovery_hash;
        adminUser.passwordRecoveryDate = data.password_recovery_date;
        adminUser.dateModified = data.date_modified;
        adminUser.dateLastLogin = data.date_last_login;
        adminUser.pushPlatform = data.push_platform;
        adminUser.pushToken = data.push_token;
        adminUser.shuttlePushToken = data.shuttle_push_token;
        adminUser.appVersion = data.app_version;
        adminUser.appPlatform = data.app_platform;
        adminUser.last_shuttles_message_acknowledged = data.last_shuttles_message_acknowledged;
        adminUser.agentStatus = data.agent_status;
        adminUser.statusTimestamp = data.status_timestamp;
        adminUser.idReservation = data.id_reservation;
        adminUser.positionTimestamp = data.position_timestamp;
        adminUser.lat = data.lat;
        adminUser.lng = data.lng;
        adminUser.waiting = data.waiting;
        adminUser.predictionDistance = data.prediction_distance;
        adminUser.predictionDuration = data.prediction_duration;
        adminUser.idGeofence = data.id_geofence;
        adminUser.geofenceInTimestamp = data.geofence_in_timestamp;
        adminUser.multireception = data.multireception;
        adminUser.idMultireceptionTerminal = data.id_multireception_terminal;
        adminUser.is_queued = data.is_queued;
        adminUser.user_status = data.user_status ? AdminUserStatusBuilder.buildAdminUserStatus(data.user_status) : null;
        adminUser.premium_status_queue = data.premium_status_queue ? data.premium_status_queue.map(item => PremiumStatusQueueItemBuilder.buildPremiumStatusQueueItem(item)) : null;
        return adminUser;
    }
    static buildAdminUsersList(data) {
        const adminUsersList = new AdminUsersList();
        adminUsersList.page = data.page;
        adminUsersList.totalCount = data.total;
        adminUsersList.pagination = data.pagination;
        adminUsersList.users = _.map(data.users, (user) => {
            return AdminUserBuilder.buildAdminUser(user);
        });
        return adminUsersList;
    }
}
//# sourceMappingURL=adminUser-builder.js.map